import { memo } from 'react';

const FallingPetals = memo(() => {
  // Criar 40 pétalas com posições e animações variadas
  const petals = Array.from({ length: 40 }, (_, i) => ({
    id: i,
    left: Math.random() * 100,
    delay: Math.random() * 8,
    duration: 12 + Math.random() * 8,
    size: 12 + Math.random() * 8,
  }));

  return (
    <div className="fixed inset-0 pointer-events-none overflow-hidden z-0">
      {petals.map((petal) => (
        <div
          key={petal.id}
          className="absolute petal"
          style={{
            left: `${petal.left}%`,
            animationDelay: `${petal.delay}s`,
            animationDuration: `${petal.duration}s`,
            width: `${petal.size}px`,
            height: `${petal.size}px`,
          }}
        />
      ))}
      <style>{`
        @keyframes fall-and-sway {
          0% {
            transform: translateY(-10vh) translateX(0) rotate(0deg);
            opacity: 0;
          }
          10% {
            opacity: 1;
          }
          90% {
            opacity: 1;
          }
          100% {
            transform: translateY(110vh) translateX(40px) rotate(360deg);
            opacity: 0;
          }
        }

        .petal {
          background: linear-gradient(135deg, hsl(330 50% 90% / 0.8), hsl(340 60% 95% / 0.6));
          border-radius: 50% 0 50% 0;
          animation: fall-and-sway infinite ease-in-out;
          will-change: transform;
          box-shadow: 0 2px 4px hsl(330 50% 70% / 0.2);
        }

        .petal:nth-child(3n) {
          background: linear-gradient(135deg, hsl(310 55% 92% / 0.7), hsl(320 60% 96% / 0.5));
          border-radius: 0 50% 0 50%;
        }

        .petal:nth-child(5n) {
          background: linear-gradient(135deg, hsl(0 0% 100% / 0.8), hsl(330 40% 98% / 0.6));
          border-radius: 45% 55% 50% 50%;
        }
      `}</style>
    </div>
  );
});

FallingPetals.displayName = 'FallingPetals';

export default FallingPetals;
